import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { scheduleSearchService } from "../../../services/ScheduleSearchService";
import { func } from "prop-types";
import { useAdvanceSearchContext } from "./AdvanceSearchContextTest";
import moment from "moment";
import SortedHeader from "../../../components/Tables/SortedHeader";
import IconThreeDots from "../../../layout/others/three-dots.svg";
import { CommonService } from "../../../services/CommonService";
import { ValidateFields } from "./ValidateFields";
import { act } from "react-dom/test-utils";
import SaveSearch from "./SaveSearch";
import { TagService } from "../../../services/TagService";

export default function MySearches() {
  let { t } = useTranslation();
  const {
    setSearchObject,
    executeScheduleSearch,
    searches,
    setSearches,
    storedSearch,
    setStoredSearch,
    buttonStatus,
    setActiveTab,
    changeCardStatus,
    setButtonStatus,
    saveSearch
  } = useAdvanceSearchContext();

  const [skills, setSkills] = useState([]);

  const [zones, setZones] = useState([]);
  const [jobRoles, setJobRoles] = useState([]);
  const [yearsOfExperienceOptions, setYearsOfExperienceOptions] = useState([]);
  const [seniorityLevels, setSeniorityLevels] = useState([]);
  const [languageLevels, setLanguageLevels] = useState([]);
  const [showSaveSearch, setShowSaveSearch] = useState(false);
  const [tagsList, setTagsList] = useState([]);

  useEffect(() => {
    CommonService.getAllSkills().then((data) => setSkills(data));

    CommonService.getAllAddressZone().then((data) => setZones(data));
    CommonService.getAllJobRoles().then((data) => setJobRoles(data));
    CommonService.getAllYearsExperience().then((data) =>
      setYearsOfExperienceOptions(data)
    );
    CommonService.getAllSeniorityLevels().then((data) =>
      setSeniorityLevels(data)
    );
    CommonService.getAllLanguageLevels().then((data) =>
      setLanguageLevels(data)
    );
    TagService.getTagsList().then((data) => {
      setTagsList(data);
    });
  }, []);

  const [headers, setHeaders] = useState([
    { label: t("Search Name") },
    { label: t("Active") },
    { label: t("Created Date") },
    { label: "" }
  ]);

  useEffect(() => {
    scheduleSearchService.getMySearches().then((data) => {
      setSearches(data);
    });
  }, []);
  function submitSearch(search) {
    let _searchObject = JSON.parse(search.searchObject);
    loadSearch(_searchObject);

    executeScheduleSearch(_searchObject);
  }
  function editFields(e, search) {
    e.stopPropagation();
    let _searchObject = JSON.parse(search.searchObject);
    loadSearch(_searchObject);
    setStoredSearch(search);
    setActiveTab("search");
  }

  function loadSearch(_searchObject) {
    let cardList = [
      "condition",
      "education",
      "work",
      "personal",
      "global",
      "competence"
    ];
    let _buttonStatus = {};
    let activeCard = "";
    for (let card of cardList) {
      let value = ValidateFields[card](_searchObject);

      if (value.length > 0) {
        _buttonStatus[card] = true;
        activeCard = card;
      } else _buttonStatus[card] = false;
    }
    if (!buttonStatus[activeCard]) changeCardStatus(activeCard);

    setButtonStatus(_buttonStatus);
    setSearchObject(_searchObject);
  }

  function ativateSearch(e, searchId) {
    e.stopPropagation();
    scheduleSearchService.activateSearch(searchId).then((data) => {
      let _searches = [...searches];
      let search = _searches.find((x) => x.id == searchId);
      search.active = true;
      setSearches(_searches);
    });
  }
  function deactivateSearch(e, searchId) {
    e.stopPropagation();
    scheduleSearchService.deactivateSearch(searchId).then((data) => {
      let _searches = [...searches];
      let search = _searches.find((x) => x.id == searchId);
      search.active = false;
      setSearches(_searches);
    });
  }
  function deleteSearch(e, searchId) {
    e.stopPropagation();
    scheduleSearchService.deleteSearch(searchId).then((data) => {
      let _searches = [...searches];
      let search = _searches.find((x) => x.id == searchId);
      let index = _searches.indexOf(search);
      _searches.splice(index, 1);
      setSearches(_searches);
    });
  }
  function editName(e, search) {
    e.stopPropagation();
    loadSearch(JSON.parse(search.searchObject));
    setStoredSearch(search);
    setShowSaveSearch(true);
  }
  function cancelEditName() {
    setStoredSearch(null);
    setShowSaveSearch(false);
  }

  return (
    <div className="table-wrap interview-list">
      <table>
        <thead>
          <SortedHeader headers={headers} setHeaders={setHeaders} />
        </thead>
        <tbody>
          {searches.map((search) => (
            <tr key={search.id} onClick={() => submitSearch(search)}>
              <td>{search.name}</td>
              <td>
                {search.active && (
                  <i class="bi bi-circle-fill" style={{ color: "green" }}></i>
                )}
              </td>

              <td>{moment(search.createdDate).format("DD-MM-YYYY")}</td>
              <td style={{ width: "25px" }}>
                <div className="dropdown">
                  <button
                    className="action-button"
                    type="button"
                    id="export"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <img
                      src={IconThreeDots}
                      alt="threedots"
                      title={t("Options")}
                    />
                  </button>
                  <ul
                    className="dropdown-menu adjust-dropdown"
                    aria-labelledby="more"
                  >
                    <li>
                      <a
                        href="#!"
                        onClick={(e) => editName(e, search)}
                        className=" dropdown-item"
                        title={t("Edit Name")}
                        data-bs-toggle="tooltip"
                      >
                        {t("Editar Nome")}
                      </a>
                    </li>
                    <li>
                      <a
                        href="#!"
                        onClick={(e) => editFields(e, search)}
                        className=" dropdown-item"
                        title={t("Edit Fields")}
                        data-bs-toggle="tooltip"
                      >
                        {t("Edit Fields")}
                      </a>
                    </li>
                    {!search.active && (
                      <li>
                        <a
                          href="#!"
                          onClick={(e) => ativateSearch(e, search.id)}
                          className=" dropdown-item"
                          title={t("Activate")}
                          data-bs-toggle="tooltip"
                        >
                          {t("Activate")}
                        </a>
                      </li>
                    )}
                    {search.active && (
                      <li>
                        <a
                          href="#!"
                          onClick={(e) => deactivateSearch(e, search.id)}
                          className=" dropdown-item"
                          title={t("Desactivate")}
                          data-bs-toggle="tooltip"
                        >
                          {t("Desactivate")}
                        </a>
                      </li>
                    )}

                    <li>
                      <a
                        href="#!"
                        className=" dropdown-item"
                        onClick={(e) => deleteSearch(e, search.id)}
                        title={t("Delete")}
                        data-bs-toggle="tooltip"
                      >
                        {t("Delete")}
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <SaveSearch
        title={t("Edit Search")}
        show={showSaveSearch}
        saveSearch={saveSearch}
        setShow={setShowSaveSearch}
        cancel={cancelEditName}
      />
    </div>
  );
}
